<template>
  <div class="comp-online-status">
    <div v-if="getStatusName(commStatus)"
    :style="{
      borderRadius: radius
    }"
    class="online-status"
    :class="{
      offline: commStatus == 0,
      online: commStatus == 1,
      unknown: commStatus == 2,
      disabled: commStatus == 3,
      onlineBlue: onlineBlue && commStatus == 1,
  
    }">
      <span v-if="showPoint" class="point"></span>
      {{ getStatusName(commStatus) }}
    </div>
  </div>
</template>

<script setup>
import { getDictionary } from '@/api/system/dict';
import { upperCase } from 'lodash';

import { computed, onMounted, ref } from 'vue';

const props = defineProps({
  commStatus: { // 展示组织过滤器
    type: [String, Number],
    default: ''
  },
  radius: { // 展示维度过滤器
    type: String,
    default: ''
  },
  upperCase: {
    type: Boolean,
    default: false
  },
  showPoint: {
    type: Boolean,
    default: true
  },
  onlineBlue: {
    type: Boolean,
    default: false
  },
  list: {
    type: Array,
    default: () => []
  }
})

const commStatusList = ref([])

function getStatusName(status) {
  const item = commStatusList.value.find(item => item.dictKey == status) || {}
  if (upperCase) {
    return (item.i18nValue || '').toUpperCase()
  }
  return item.i18nValue || '';
}

onMounted(() => {
  if (props.list.length) {
    commStatusList.value = props.list;
  } else {
    getDictionary({code: 'commStatus'}).then(res => { // 待传入优化
      const data = res.data.data;
      commStatusList.value = data;
    })
  }
})
</script>